<template>
  <div class="percentage-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group">
          <input class="form-control" type="text"
            :class="highlightValidation ? 'is-valid' : ''"
            :id="options.name"
            :value="value"
            @input="validate($event.target.value)"
            :name="options.name"/>
          <div class="input-group-append">
            <span class="input-group-text">
              <template v-if="isRegex">
                {{ parseFloat(value) }} %
              </template>
              <template v-else>
                Invalid %
              </template>
            </span>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationMessage,
  validationIcon
} from '@/util/helpers'

export default {
  name: 'PercentageInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          value: '0'
        }
      }
    },
    onChange: {
      type: Function,
      default () {
        return false
      }
    },
    highlightValidation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLength: false,
      isRegex: false,
      regex: /^[0-9]*(\.{1}[0-9]{1,2})*$/,
      isValid: false,
      maxValue: 100,
      isDirty: false
    }
  },
  computed: {
    validationClass,
    validationMessage,
    validationIcon,
    invalidMessage () {
      if (this.maxValue && this.value > this.maxValue && this.isRegex) {
        return 'Amount cannot be more than 100%'
      } else {
        return 'The amount entered is not a valid % amount'
      }
    }
  },
  methods: {
    validate (val = this.value) {
      if (val === null) {
        val = '0'
      }
      this.$emit('input', val)
      this.onChange()
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length !== 0
        if (this.isValid) {
          this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
        }
        if (this.maxValue && this.isValid) {
          this.isValid = parseFloat(val) <= this.maxValue
        }
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PercentageInput.vue